import { Link } from 'react-router-dom';
import { categories } from '@/mocks/navigation';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="w-full">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            全部分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            八大分类，精心整理，让您快速找到需要的网站资源
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => {
            const isAccent = cat.color === 'accent';
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group p-5 md:p-6 rounded-2xl bg-background-100 hover:bg-background-200/80 border border-background-200/60 transition-all duration-300 cursor-pointer hover:scale-[1.02]"
              >
                <div
                  className={`w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center mb-4 transition-transform group-hover:scale-110 ${
                    isAccent
                      ? 'bg-accent-100 text-accent-600'
                      : 'bg-primary-100 text-primary-600'
                  }`}
                >
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </div>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-1.5">
                  {cat.name}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {cat.description}
                </p>
                <div className="flex items-center gap-1 mt-3 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity"
                  style={{ color: isAccent ? 'oklch(var(--accent-600))' : 'oklch(var(--primary-600))' }}
                >
                  <span>查看全部</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}